import PropTypes from "prop-types";
import Hero from "../components/hero";
import SalesBanner from "../components/sales-banner";
import Perks from "../components/perks";
import styles from "./styles";
import { useLocaleProvider, useTranslate } from "../context/locale-provider";

export default function OurAppsLayout({ imageLinksDesktop, imageLinksMobile }) {
  const translate = useTranslate(useLocaleProvider());

  return (
    <div>
      <Hero
        imageLinksDesktop={imageLinksDesktop}
        imageLinksMobile={imageLinksMobile}
      />
      <SalesBanner />
      <Perks />
      <div className={styles.appStoreSection}>
        <div className={styles.appStore}>
          <a
            id="app-store"
            href="https://apps.apple.com/gb/app/asos/id457876088"
            aria-label={translate("ourApps_hero_appStoreIconAriaLabel")}
          >
            <div className={styles.storeIconContainer}>
              <img
                src={
                  "https://content.asos-media.com/-/media/app-download/apple-app-store.png"
                }
                alt="App Store"
                className={styles.appStoreIcon}
              />
            </div>
          </a>
          <a
            id="google-play"
            href="https://play.google.com/store/apps/details?id=com.asos.app"
            aria-label={translate("ourApps_hero_googlePlayIconAriaLabel")}
          >
            <div className={styles.storeIconContainer}>
              <img
                src={
                  "https://content.asos-media.com/-/media/app-download/google-play.png"
                }
                alt="Google Play"
                className={styles.googlePlayIcon}
              />
            </div>
          </a>
        </div>
      </div>
    </div>
  );
}

OurAppsLayout.propTypes = {
  imageLinksDesktop: PropTypes.string.isRequired,
  imageLinksMobile: PropTypes.string.isRequired,
};
